import React from 'react'
import { WidgetProps } from '@rjsf/utils'

import 'ace-builds/src-noconflict/mode-markdown'

import { EditorWidget } from './EditorWidget'

export const EditorMarkdownWidget: React.FC<WidgetProps> = props => {
  return <EditorWidget mode={'markdown'} {...props} />
}
